import { Record } from 'immutable';
import * as storageValidate from 'app/models/storage/validate';

export const LOCAL_STORAGE_PREFIX = 'localStorage';

export const INIT        = `${LOCAL_STORAGE_PREFIX}/INIT`;
export const SET_ITEM    = `${LOCAL_STORAGE_PREFIX}/SET_ITEM`;
export const REMOVE_ITEM = `${LOCAL_STORAGE_PREFIX}/REMOVE_ITEM`;
export const CLEAR       = `${LOCAL_STORAGE_PREFIX}/CLEAR`;

// Try to keep the keys used here, to prevent collisions.
export const AUTH_KEY                    = 'AUTH';
export const PREFERRED_LOCALE_KEY        = 'PREFERRED_LOCALE';
export const SHOW_LESSON_TRANSLATIONS    = 'SHOW_LESSON_TRANSLATIONS';
export const DMM_SESSION_DATA            = 'DMM_SESSION_DATA';
export const WEBRTC_DEBUG                = 'WEBRTC_DEBUG';
export const HELLO_CONTINUATION          = 'EIKAIWA_HELLO_CONTINUATION';
export const DEVICE_MANAGER_SETTINGS     = 'DEVICE_MANAGER_SETTINGS';
export const CHAT_SEND_ON_ENTER          = 'CHAT_SEND_ON_ENTER';
export const EDITOR_DATE_TIME_KEY        = 'EDITOR_DATE_TIME_KEY';
export const HIDE_BIBO_NAME_CHANGE_MODAL = 'HIDE_BIBO_NAME_CHANGE_MODAL';
export const ROOMS_CREDENTIALS_STORE_KEY = 'ROOMS_CREDENTIALS';
export const PERSISTED_MATERIAL_LANGUAGE = 'PERSISTED_MATERIAL_LANGUAGE';

export const Storage = new Record({
  [AUTH_KEY]:                    null,
  [PREFERRED_LOCALE_KEY]:        null,
  [SHOW_LESSON_TRANSLATIONS]:    true,
  [DMM_SESSION_DATA]:            null,
  [WEBRTC_DEBUG]:                false,
  [DEVICE_MANAGER_SETTINGS]:     null,
  [CHAT_SEND_ON_ENTER]:          undefined,
  [EDITOR_DATE_TIME_KEY]:        null,
  [HIDE_BIBO_NAME_CHANGE_MODAL]: undefined,
  [ROOMS_CREDENTIALS_STORE_KEY]: undefined,
  [PERSISTED_MATERIAL_LANGUAGE]: undefined,
})();

export const validateKey = storageValidate.validateKey(Storage);
